import { CircularLoader } from 'seagull';
import { RichTextViewer } from 'seagull/components/RichTextViewer';
import { getTestIds } from 'seagull/utils/TestIds';
import { QueryKeys } from "../../hooks/reactQuery/queryKeys";
import { useQueryState } from "../../hooks/reactQuery/useQueryState";
import styles from "./QuillViewerWithFetch.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const QuillViewerWithFetchTestIds = getTestIds('QuillViewerWithFetchTestIds');
function toQuillDelta(richTextContent) {
  return {
    type: 'quill-delta',
    value: richTextContent
  };
}
export function QuillViewerWithFetch(_ref) {
  let {
    fetchContent,
    queryKey
  } = _ref;
  const {
    data: content,
    isLoading
  } = useQueryState({
    queryKey: [QueryKeys.RichText, queryKey],
    queryFn: () => fetchContent === null || fetchContent === void 0 ? void 0 : fetchContent(),
    enabled: !!fetchContent
  });
  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      "data-testid": QuillViewerWithFetchTestIds.Loader(),
      style: {
        position: 'absolute',
        top: 'calc(50% - 16px)',
        left: 'calc(50% - 16px)'
      },
      children: /*#__PURE__*/_jsx(CircularLoader, {
        size: 32
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    "data-testid": QuillViewerWithFetchTestIds.Container(),
    children: /*#__PURE__*/_jsx(RichTextViewer, {
      value: toQuillDelta(content !== null && content !== void 0 ? content : [])
    })
  });
}